export interface ComponentDef {
  id: string;
  label: string;
  emoji: string;
  description: string;
}

export interface ComponentCategory {
  name: string;
  items: ComponentDef[];
}

export const COMPONENT_LIBRARY: ComponentCategory[] = [
  {
    name: 'Layout',
    items: [
      { id: 'navbar',    label: 'Navbar',      emoji: '☰',  description: 'Top navigation bar with logo and links' },
      { id: 'hero',      label: 'Hero',        emoji: '🖼️',  description: 'Large hero section with headline and CTA' },
      { id: 'footer',    label: 'Footer',      emoji: '⬛',  description: 'Page footer with links and info' },
      { id: 'two-col',   label: '2 Columns',   emoji: '⊟',  description: 'Two-column layout section' },
      { id: 'three-col', label: '3 Columns',   emoji: '⊞',  description: 'Three-column layout section' },
      { id: 'container', label: 'Container',   emoji: '▭',  description: 'Centered content container' },
      { id: 'divider',   label: 'Divider',     emoji: '─',  description: 'Horizontal section divider' },
    ],
  },
  {
    name: 'Content',
    items: [
      { id: 'heading',   label: 'Heading',     emoji: 'H',  description: 'Section heading with optional subtitle' },
      { id: 'paragraph', label: 'Paragraph',   emoji: '¶',  description: 'Text paragraph block' },
      { id: 'image',     label: 'Image',       emoji: '🖼️',  description: 'Image placeholder with caption' },
      { id: 'card',      label: 'Card',        emoji: '🃏',  description: 'Content card with title and body' },
      { id: 'table',     label: 'Table',       emoji: '⊞',  description: 'Data table with rows and columns' },
      { id: 'list',      label: 'List',        emoji: '≡',  description: 'Bulleted or numbered list' },
      { id: 'badge',     label: 'Badge',       emoji: '◉',  description: 'Small label or tag badge' },
      { id: 'quote',     label: 'Quote',       emoji: '"',  description: 'Blockquote or testimonial' },
      { id: 'code',      label: 'Code Block',  emoji: '<>', description: 'Syntax-highlighted code snippet' },
    ],
  },
  {
    name: 'Forms',
    items: [
      { id: 'button',    label: 'Button',      emoji: '▶',  description: 'Clickable action button' },
      { id: 'input',     label: 'Input',       emoji: '▭',  description: 'Single-line text input' },
      { id: 'checkbox',  label: 'Checkbox',    emoji: '☑',  description: 'Checkbox with label' },
      { id: 'radio',     label: 'Radio',       emoji: '◎',  description: 'Radio button group' },
      { id: 'select',    label: 'Dropdown',    emoji: '▼',  description: 'Select dropdown menu' },
      { id: 'textarea',  label: 'Textarea',    emoji: '▬',  description: 'Multi-line text area' },
      { id: 'form',      label: 'Form',        emoji: '📋', description: 'Complete form with multiple fields' },
      { id: 'toggle',    label: 'Toggle',      emoji: '⬤',  description: 'On/off toggle switch' },
    ],
  },
  {
    name: 'Navigation',
    items: [
      { id: 'tabs',        label: 'Tabs',        emoji: '⊟',  description: 'Tabbed navigation panel' },
      { id: 'breadcrumb',  label: 'Breadcrumb',  emoji: '›',  description: 'Breadcrumb navigation trail' },
      { id: 'pagination',  label: 'Pagination',  emoji: '«»', description: 'Page navigation controls' },
      { id: 'sidebar-nav', label: 'Sidebar Nav', emoji: '▌',  description: 'Vertical sidebar navigation' },
    ],
  },
  {
    name: 'Sections',
    items: [
      { id: 'pricing',      label: 'Pricing',      emoji: '💰', description: 'Pricing tiers comparison' },
      { id: 'testimonials', label: 'Testimonials', emoji: '💬', description: 'Customer testimonial cards' },
      { id: 'team',         label: 'Team Grid',    emoji: '👥', description: 'Team member profile cards' },
      { id: 'features',     label: 'Features',     emoji: '✨', description: 'Feature highlights grid' },
      { id: 'cta',          label: 'CTA',          emoji: '📣', description: 'Call-to-action section' },
      { id: 'stats',        label: 'Stats Bar',    emoji: '📊', description: 'Key statistics display' },
      { id: 'gallery',      label: 'Gallery',      emoji: '🖼️',  description: 'Image or media gallery grid' },
      { id: 'faq',          label: 'FAQ',          emoji: '❓', description: 'Accordion FAQ section' },
    ],
  },
];
